import React from "react";
import loadable from "@loadable/component";

const ProxyGallery = (props) => {
  const Loaded = loadable(() => import("../Gallery"));
  return <Loaded {...props} />;
};

export default ProxyGallery;
